// src/components/HeaderPreview.js
import React from "react";
import { Box, Typography } from "@mui/material";
import { useExamDetails } from "../../context/ExamDetailsContext";

const HeaderPreview = ({ school }) => {
  const { firstExamDetails, loading, error } = useExamDetails();

  if (loading) {
    return (
      <Box
        sx={{
          border: "1px solid #ccc",
          borderRadius: "8px",
          p: 2,
          mb: 3,
          textAlign: "center",
        }}
      >
        <Typography>Loading exam details...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          border: "1px solid #ccc",
          borderRadius: "8px",
          p: 2,
          mb: 3,
          textAlign: "center",
          backgroundColor: "#ffebee",
        }}
      >
        <Typography color="error">Error: {error}</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        border: "1px solid #ccc",
        borderRadius: "8px",
        p: 2,
        mb: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      {/* Left - Logo + Affiliation */}
      <Box
        sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
      >
        {school?.logo && (
          <img
            src={school.logo}
            alt="School Logo"
            style={{
              width: "80px",
              height: "80px",
              objectFit: "contain",
              marginBottom: "5px",
            }}
          />
        )}
        <Typography variant="caption" fontWeight="bold">
          Affiliation No: {school?.affiliation_number || "N/A"}
        </Typography>
      </Box>

      {/* Center - School Name + Board */}
      <Box sx={{ textAlign: "center", flexGrow: 1 }}>
        <Typography variant="h6" fontWeight="bold">
          {school?.school_name || "SCHOOL NAME"}
        </Typography>
        <Typography variant="body2">SENIOR SECONDARY</Typography>
        <Typography variant="body2">
          {school?.affiliated_board || "CBSE"}
        </Typography>
      </Box>

      {/* Right - Exam Info */}
      <Box sx={{ textAlign: "right" }}>
        <Typography
          sx={{
            fontWeight: "bold",
            color: "green",
            px: 1,
            borderRadius: "4px",
            display: "inline-block",
          }}
        >
          {firstExamDetails?.test_paper_name ||
            school?.exam_type ||
            "TEST NAME"}
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          Time : {firstExamDetails?.time_allowed || "N/A"}
        </Typography>
        <Typography variant="body2">
          FULL MARKS: {firstExamDetails?.full_marks || school?.full_marks || "N/A"}
        </Typography>
      </Box>
    </Box>
  );
};

export default HeaderPreview;
